import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class DebugAnalyticsService {
  get debug(): boolean {
    if (this._debug === undefined) {
      this._debug = Boolean(this.winRef.nativeWindow?.localStorage?.getItem('debug-analytics'));
    }

    return this._debug;
  }

  private _debug: boolean | undefined;

  constructor(private winRef: WindowRef) {}
}
